import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=0345d18a&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Information.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Information.vue
// module id = 2417
// module chunks = 1